import LayoutConfigTypes from '@/core/config/LayoutConfigTypes';

const config: LayoutConfigTypes = {
  themeName: 'Keyapp',
  themeVersion: '8.0.38',
  demo: 'demo1',
  main: {
    type: 'default',
    primaryColor: '#00A3FF',
    logo: {
      dark: '/media/logos/logo.svg',
      light: '/media/logos/logo.svg',
    },
  },
  illustrations: {
    set: 'sketchy-1',
  },
  loader: {
    logo: '/media/logos/logo.svg',
    display: true,
    type: 'default',
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: 'font',
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: true,
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  aside: {
    display: true,
    theme: 'dark',
    fixed: true,
    menuIcon: 'font',
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  chat: {
    display: false,
  },
  content: {
    width: 'fluid',
  },
  footer: {
    width: 'fluid',
  },
  iconPaths: {
    countryFlag: '/media/svg/country/flags/4x3/'
  }
};

export default config;
